// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_iz","advertCardPhoto__image":"c-a_iA"};